import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

interface Props {
  offer: App.Offer
}

const Root = styled(Group)`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const Image = styled.div`
  height: 100%;
  min-height: ${rem(140)};
  min-width: ${rem(120)};
  background-position: center;
  background-size: cover;

  ${mediaQueryUp.tablet} {
    min-height: ${rem(118)};
    min-width: ${rem(100)};
  }
`

const ContentContainer = styled(Group)`
  padding: ${rem(20)};
`

function ExpiredDealsOfferPill({
  offer,
}: Props) {
  const { image, property } = offer
  const intl = useIntl()
  const propertyName = property?.name
  const imageId = image?.id

  const pillImageStyle = useMemo<React.CSSProperties>(() => {
    const imageUrl = imageId && getImageUrl(imageId, { height: 230 })
    return {
      backgroundImage: `url(${imageUrl})`,
    }
  }, [imageId])

  const youJustMissedItText = intl.formatMessage({
    id: 'Xd8kCXjCRkl0biJh2xKf',
    defaultMessage: 'You just missed it!',
    description: 'Heading for expired deal offer pill indicating the deal has ended',
  })
  const body = propertyName
    ? intl.formatMessage(
        {
          id: 'Hjk5__2ewEThh2Nmu0Bg',
          defaultMessage: 'The {propertyName} offer is now over, but checkout other great deals below.',
          description: 'Body text for expired deal with a specific hotel property name',
        },
        { propertyName },
      )
    : intl.formatMessage({
        id: 'U3XEtBhtmar-wuEnEMVa',
        defaultMessage: 'This offer is now over, but checkout other great deals below.',
        description: 'Body text for expired deal without a specific hotel property name',
      })

  return (
    <LayoutContainer>
      <Root direction="horizontal">
        <Image style={pillImageStyle} />
        <ContentContainer direction="vertical" gap={4} verticalAlign="center">
          <Heading variant="heading5">
            {youJustMissedItText}
          </Heading>
          <BodyText variant="small">
            {body}
          </BodyText>
        </ContentContainer>
      </Root>
    </LayoutContainer>
  )
}

export default ExpiredDealsOfferPill
